import { z } from 'zod'

export const dateRangeSchema = z.object({
  id: z.string(),
  start_date: z.string().datetime().nullable(),
  end_date: z.string().datetime().nullable(),
  status: z.string(),
  // When the date range is initially created, sometimes PonyORM doesn't actually set the start date
  created_at: z.string().datetime().nullable(),
})

export type DateRange = z.infer<typeof dateRangeSchema>
